import {galileo} from "@galileo/galileo-web-sdk";

class Galileo {
  constructor() {
    galileo.setTimeout(3000)
    galileo.setEnvironment(`${process.env.REACT_APP_GALILEO_ENV}`)
  }

  async fetchOnboarderLoginFlag() {
    return await galileo.getBool(
        "onboard/identity_web_login_enabled",
        {},
        false
    );
  }

  async fetchOnboarderSignupFlag() {
    return await galileo.getBool(
        "onboard/identity_web_signup_enabled",
        {},
        false
    );
  }
}

export default new Galileo();
